import React from "react";
import OptionsSwal from "../../components/Swal/optionsSwal";
import useApi from "../useApi";
import ColaboradoresApiClient from "../../api/colaboradores";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import { AppContext } from "../../contexts/AppContext";

export default function useDocumentosColaborador(uid) {
  const [documentos, setDocumentos] = React.useState([]);
  const [documentosAdmissao, setDocumentosAdmissao] = React.useState({});
  const [uploadDocumentoModal, setUploadDocumentoModal] = React.useState(false);
  const [uploadValues, setUploadValues] = React.useState({});
  const { session } = React.useContext(AppContext);

  const { request: getDocumentosAtivo, data: documentosAtivoResponse } = useApi(
    ColaboradoresApiClient.getDocumentosAtivo
  );
  const { request: apagaDocumento } = useApi(
    ColaboradoresApiClient.apagaDocumento
  );
  const postDocumentosApi = useApi(ColaboradoresApiClient.postDocumentosAtivo);

  //Busca documentos do colaborador ao renderizar tela
  React.useEffect(() => {
    if (!uid || !session?.empresa) return;
    getDocumentosAtivo(session.empresa.replace(/E/gi, ""), uid);
  }, [getDocumentosAtivo, session.empresa, uid]);

  //Define estado ao receber documentos do colaborador
  React.useEffect(() => {
    if (!documentosAtivoResponse) return;
    setDocumentos(() => [...documentosAtivoResponse]);
  }, [documentosAtivoResponse]);

  //Define estado ao receber documentos do colaborador
  React.useEffect(() => {
    if (!documentosAtivoResponse) return;
    const documentosMapeados = {
      cnh_rg: documentosAtivoResponse.find((documento) => documento.tipo === 1),
      contrato_faculdade: documentosAtivoResponse.find(
        (documento) => documento.tipo === 4
      ),
      exame_admissional: documentosAtivoResponse.find(
        (documento) => documento.tipo === 3
      ),
      titulo_ir: documentosAtivoResponse.find(
        (documento) => documento.tipo === 2
      ),
    };

    setDocumentosAdmissao(documentosMapeados);
  }, [documentosAtivoResponse]);

  const togUploadModal = () => {
    setUploadValues({});
    setUploadDocumentoModal(true);
  };

  const excluirDocumento = React.useCallback(
    async (uid_documento) => {
      OptionsSwal({
        title: "Você deseja realmente excluir o documento?",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const formData = new FormData();
          formData.append("caminho", uid_documento);
          const response = await apagaDocumento(
            session.empresa.replace(/E/gi, ""),
            uid,
            formData
          );
          if (!response) return;
          getDocumentosAtivo(session.empresa.replace(/E/gi, ""), uid);
        }
      });
    },
    [apagaDocumento, getDocumentosAtivo, session.empresa, uid]
  );

  const uploadDocumento = async (descricao = null, arquivo = null) => {
    const formData = new FormData();
    formData.append("descricao", descricao ?? uploadValues?.descricao);
    formData.append("arquivo", arquivo ?? uploadValues?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postDocumentosApi.request(
      session.empresa.replace(/E/gi, ""),
      uid,
      formData
    );
    if (!response) return;
    setUploadDocumentoModal(false);
    getDocumentosAtivo(session.empresa.replace(/E/gi, ""), uid);
  };

  return {
    uploadValues,
    setUploadValues,
    documentos,
    documentosAdmissao,
    setDocumentosAdmissao,
    uploadDocumentoModal,
    setUploadDocumentoModal,
    togUploadModal,
    excluirDocumento,
    uploadDocumento,
  };
}
